import React, { useState, useEffect } from 'react';
import { X, Search, Warehouse, Save, Loader2, MapPin, ArrowRightLeft, Tag, DollarSign, Calculator, Lock } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';
import UniversalLookup from './UniversalLookup';

const AddItemToStoreModal = ({ isOpen, onClose, itemnum, onRefresh }) => {
  const [storeData, setStoreData] = useState({ 
    location: '', 
    siteid: '', 
    orderunit: '', 
    issueunit: '',
    curbal: 0,   // ?????? ?????????
    avgcost: 0   // ????? ??????
  });
  
  const [lookup, setLookup] = useState({ isOpen: false, title: '', type: '', field: '', filters: {} });
  const [loading, setLoading] = useState(false);

  // ???? ?????? ?????? ??????
  const totalValue = (Number(storeData.curbal) * Number(storeData.avgcost)).toFixed(2);

  // 1. ??? ??????? ?????????? ?? ?????
  useEffect(() => {
    if (isOpen && itemnum) {
      const fetchItemUnits = async () => {
        try {
          const res = await axios.get(`/api/items/${itemnum}`);
          setStoreData(prev => ({
            ...prev,
            orderunit: res.data.orderunit || '',
            issueunit: res.data.issueunit || ''
          }));
        } catch (err) {
          console.error("Error fetching units:", err);
        }
      };
      fetchItemUnits();
    } else {
      setStoreData({ location: '', siteid: '', orderunit: '', issueunit: '', curbal: 0, avgcost: 0 });
    }
  }, [isOpen, itemnum]);

  if (!isOpen) return null;

  // 2. ???? ?????
  const handleAssign = async () => {
    if (!storeData.location || !storeData.siteid) {
      return toast.error("Please select a Storeroom first");
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/inventory/assign', {
        itemnum: itemnum,
        ...storeData,
        curbal: Number(storeData.curbal),
        avgcost: Number(storeData.avgcost)
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      toast.success(`Item initialized in ${storeData.location} successfully`);
      onRefresh(); 
      onClose();   
    } catch (err) {
      toast.error(err.response?.data?.detail || "Initialization failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[4000] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200 uppercase font-sans">
      <div className="bg-white w-[600px] shadow-2xl rounded-sm overflow-hidden border border-gray-300 animate-in zoom-in-95">
        
        {/* Header */}
        <div className="bg-[#1a3353] text-white p-4 flex justify-between items-center shadow-md border-b border-blue-400/20">
          <div className="flex items-center gap-3">
            <Warehouse size={18} className="text-blue-300" />
            <span className="text-[11px] font-black tracking-widest uppercase italic text-blue-50">Assign Item to Storeroom</span>
          </div>
          <button onClick={onClose} className="hover:bg-red-600 p-1 rounded-full transition-colors text-white">
            <X size={18}/>
          </button>
        </div>

        {/* Content */}
        <div className="p-8 space-y-6 bg-gray-50/50 max-h-[80vh] overflow-y-auto custom-scrollbar">
          
          {/* Item Identification */}
          <div className="flex items-center justify-between border-b border-gray-200 pb-3 bg-white p-3 rounded shadow-sm border-l-4 border-l-blue-600">
             <div className="flex flex-col">
                <label className="text-[8px] font-black text-gray-400 tracking-widest uppercase italic">Master Record</label>
                <span className="text-[#1a3353] font-black text-sm">{itemnum}</span>
             </div>
             <Tag size={20} className="text-gray-200" />
          </div>

          {/* Location & Locked Site selection */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col gap-1 border-b border-gray-300 group focus-within:border-blue-600 transition-all">
                <label className="text-[9px] font-black text-gray-400 tracking-widest uppercase">Storeroom Location</label>
                <div className="flex items-center justify-between py-1">
                    <span className={`font-black text-[11px] ${storeData.location ? 'text-blue-900' : 'text-gray-300 italic'}`}>
                        {storeData.location || 'SEARCH STOREROOM...'}
                    </span>
                    <button onClick={() => setLookup({ isOpen: true, title: 'Storerooms', type: 'storerooms', field: 'location' })}>
                        <Search size={14} className="text-blue-600 hover:scale-110 transition-transform" />
                    </button>
                </div>
            </div>

            <div className="flex flex-col gap-1 border-b border-gray-100 bg-gray-100/50 p-1 rounded-t opacity-80 cursor-not-allowed">
                <label className="text-[9px] font-black text-gray-400 tracking-widest uppercase flex items-center gap-2">
                   <Lock size={10}/> Site ID (Locked)
                </label>
                <div className="flex items-center justify-between py-1">
                    <span className="font-black text-gray-600 text-[11px]">
                        {storeData.siteid || '--- AUTO ---'}
                    </span>
                </div>
            </div>
          </div>

          {/* Opening Balance Valuation */}
          <div className="bg-white p-5 border rounded-sm shadow-sm space-y-5 border-t-4 border-t-green-600">
             <div className="flex items-center gap-2 text-green-700 font-black mb-2">
                <DollarSign size={14}/> 
                <span className="text-[9px] tracking-widest uppercase">Opening Stock Valuation</span>
             </div>

             <div className="grid grid-cols-2 gap-8">
                <div className="flex flex-col border-b border-gray-200 focus-within:border-green-600 transition-all">
                    <label className="text-[8px] font-black text-gray-400 uppercase tracking-tighter">Initial Quantity</label>
                    <input 
                        type="number"
                        className="font-black text-blue-900 outline-none py-2 bg-transparent text-lg font-mono placeholder:text-gray-200"
                        value={storeData.curbal}
                        onChange={(e) => setStoreData({...storeData, curbal: e.target.value})}
                    />
                </div>
                <div className="flex flex-col border-b border-gray-200 focus-within:border-green-600 transition-all text-right">
                    <label className="text-[8px] font-black text-gray-400 uppercase tracking-tighter">Unit Cost (Avg)</label>
                    <input 
                        type="number"
                        className="font-black text-blue-900 outline-none py-2 bg-transparent text-lg text-right font-mono placeholder:text-gray-200"
                        value={storeData.avgcost}
                        onChange={(e) => setStoreData({...storeData, avgcost: e.target.value})}
                    />
                </div>
             </div>

             <div className="bg-green-50 p-3 rounded flex justify-between items-center border border-green-100">
                <div className="flex items-center gap-2">
                    <Calculator size={16} className="text-green-600"/>
                    <span className="text-[9px] font-black text-green-800 uppercase tracking-widest italic">Inventory Total:</span>
                </div>
                <span className="text-xl font-black text-green-700 font-mono tracking-tighter">
                    {totalValue} <span className="text-[10px] font-sans">EGP</span>
                </span>
             </div>
          </div>

          {/* Tracking Units */}
          <div className="bg-white p-4 border rounded-sm shadow-sm space-y-4 border-t-4 border-t-[#1a3353]">
            <div className="flex items-center gap-2 mb-2 text-[#1a3353] font-black">
                <ArrowRightLeft size={14} className="text-blue-600"/>
                <span className="text-[9px] tracking-widest uppercase">Tracking Units</span>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
                <UnitLookupField label="Order Unit" value={storeData.orderunit} onSearch={() => setLookup({ isOpen: true, title: 'UOM', type: 'DOMAIN', domainId: 'UOM', field: 'orderunit' })} />
                <UnitLookupField label="Issue Unit" value={storeData.issueunit} onSearch={() => setLookup({ isOpen: true, title: 'UOM', type: 'DOMAIN', domainId: 'UOM', field: 'issueunit' })} />
            </div>
          </div>

          <div className="bg-blue-50/50 p-4 border-l-4 border-blue-900 flex gap-3 items-start shadow-inner">
             <MapPin size={16} className="text-blue-600 shrink-0 mt-0.5"/>
             <p className="text-[9px] text-blue-900 font-bold italic leading-relaxed uppercase tracking-tighter">
               Assigning an item to a storeroom locks it to that site. Financial transactions will be generated based on the initial quantity provided.
             </p>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="p-4 bg-gray-100 border-t flex justify-end gap-3 px-8 shadow-inner">
          <button onClick={onClose} className="px-6 py-2 text-[10px] font-black text-gray-500 hover:bg-gray-200 rounded transition-all uppercase tracking-widest">Cancel</button>
          <button 
            onClick={handleAssign}
            disabled={loading}
            className="bg-[#1a3353] hover:bg-blue-900 text-white px-8 py-2 rounded-sm font-black flex items-center gap-2 shadow-lg transition-all active:scale-95 disabled:opacity-50 uppercase tracking-widest"
          >
            {loading ? <Loader2 className="animate-spin" size={14}/> : <Save size={14} />}
            Finalize Initialization
          </button>
        </div>

        <UniversalLookup 
          {...lookup} 
          onClose={() => setLookup({ ...lookup, isOpen: false })}
          onSelect={(row) => {
            // Row ?? ?????? ???? ???? ?? ?????
            // ???? ????? ???? ????? ??????? ???????? ??????? (location, site_id)
            const locValue = row.location || row.location_id || row.id;
            const siteValue = row.site_id || row.siteid;
        
            if (lookup.field === 'location') {
                setStoreData(prev => ({ 
                    ...prev, 
                    location: locValue, 
                    siteid: siteValue // ??? ?????? ???????????? ?? ????????
                }));
            } else {
                setStoreData(prev => ({ ...prev, [lookup.field]: row.value || row.id }));
            }
            setLookup({ ...lookup, isOpen: false });
          }}
        />
      </div>
    </div>
  );
};

// Helper Component for Units
const UnitLookupField = ({ label, value, onSearch }) => (
    <div className="flex flex-col gap-1 border-b border-gray-200 group focus-within:border-blue-500 transition-all">
        <label className="text-[8px] font-black text-gray-400 tracking-widest uppercase">{label}</label>
        <div className="flex items-center justify-between py-1 px-1">
            <span className="font-black text-blue-900 text-[11px]">{value || '---'}</span>
            <button onClick={onSearch}><Search size={13} className="text-blue-400 hover:text-blue-600" /></button>
        </div>
    </div>
);

export default AddItemToStoreModal;